import React, { useEffect } from 'react';

export const useExternalNavigationPreventOnChange = (
  changesMade,
  showPrompt,
) => {
  //NOTE: its not possible to show custom message or custom dialog instead of default browser dialog :(
  useEffect(() => {
    if (showPrompt) return;
    const handleNavigation = (event) => {
      if (changesMade) {
        event.preventDefault();
        const confirmationMessage = 'NON_EMPTY'; //see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };

    window.addEventListener('beforeunload', handleNavigation);

    return () => {
      window.removeEventListener('beforeunload', handleNavigation);
    };
  }, [changesMade, showPrompt]);
};
